import { Box, Skeleton } from "@mui/material";
import CommonPage from "../../components/common-page";

export default function OverlayTemplatesSkeleton() {
  return (
    <CommonPage>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton key={i} variant="rectangular" width="100%" height={52} sx={{ borderRadius: 1 }} />
        ))}
      </Box>
    </CommonPage>
  );
}
